module.exports = __webpack_public_path__ + "img/login_cover-boires.edb3a774.jpg";